var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval62E = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 57",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Oval-6-2-E_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 28c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 42 0 35.732 0 28ZM24.776 3.17A2.5 2.5 0 0 1 27.264.917h5.471a2.5 2.5 0 0 1 2.488 2.253l.529 5.33c.133 1.343-1.02 2.5-2.49 2.5h-6.525c-1.47 0-2.622-1.157-2.49-2.5l.53-5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M26.738 1.833c-.686 0-1.314.356-1.62.919l-.223.408c-.247.453-.848.636-1.342.41-.494-.227-.694-.777-.447-1.23l.222-.408C23.974.748 25.294 0 26.738 0h6.524c1.444 0 2.764.748 3.41 1.932l.222.408c.247.453.047 1.003-.447 1.23-.494.226-1.095.043-1.342-.41l-.222-.408c-.307-.563-.935-.919-1.621-.919h-6.524Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35.224 53.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M33.262 55.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C36.026 56.252 34.706 57 33.262 57h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41.776 3.17A2.5 2.5 0 0 1 44.264.917h5.471a2.5 2.5 0 0 1 2.488 2.253l.529 5.33c.133 1.343-1.02 2.5-2.49 2.5h-6.525c-1.47 0-2.622-1.157-2.49-2.5l.53-5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M43.738 1.833c-.686 0-1.314.356-1.62.919l-.223.408c-.247.453-.848.636-1.342.41-.494-.227-.694-.777-.447-1.23l.222-.408C40.974.748 42.294 0 43.738 0h6.524c1.444 0 2.764.748 3.41 1.932l.222.408c.247.453.047 1.003-.447 1.23-.494.226-1.095.043-1.342-.41l-.222-.408c-.307-.563-.935-.919-1.621-.919h-6.524Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18.224 53.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M16.262 55.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C19.026 56.252 17.706 57 16.262 57H9.738c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7.776 3.17A2.5 2.5 0 0 1 10.264.917h5.471a2.5 2.5 0 0 1 2.488 2.253l.529 5.33c.133 1.343-1.02 2.5-2.49 2.5H9.737c-1.47 0-2.622-1.157-2.49-2.5l.53-5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M9.738 1.833c-.686 0-1.314.356-1.62.919l-.223.408c-.247.453-.848.636-1.342.41-.494-.227-.694-.777-.447-1.23l.222-.408C6.974.748 8.294 0 9.738 0h6.524c1.444 0 2.764.748 3.41 1.932l.222.408c.247.453.047 1.003-.447 1.23-.494.226-1.095.043-1.342-.41l-.222-.408c-.307-.563-.935-.919-1.621-.919H9.738Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M52.224 53.83a2.5 2.5 0 0 1-2.488 2.254h-5.471a2.5 2.5 0 0 1-2.488-2.254l-.529-5.33c-.133-1.343 1.02-2.5 2.49-2.5h6.525c1.47 0 2.622 1.157 2.49 2.5l-.53 5.33Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M50.262 55.167c.686 0 1.314-.356 1.62-.919l.223-.408c.247-.453.848-.636 1.342-.41.494.227.694.777.447 1.23l-.222.408C53.026 56.252 51.706 57 50.262 57h-6.524c-1.444 0-2.764-.748-3.41-1.932l-.222-.408c-.247-.453-.047-1.003.447-1.23.494-.226 1.095-.043 1.342.41l.222.408c.307.563.935.919 1.621.919h6.524Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Oval-6-2-E_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v57H0z"
})))));
SvgOval62E.viewBox = '0 0 60 57';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval62E);
export default ForwardRef;